var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vux-loader/src/script-loader.js!../vue-loader/lib/selector?type=script&index=0!./slide.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4fcba7f0\"}!../vux-loader/src/before-template-compiler-loader.js!../vux-loader/src/template-loader.js!../vue-loader/lib/selector?type=template&index=0!./slide.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-awesome-swiper@2.5.4@vue-awesome-swiper/slide.vue
// module id = 283
// module chunks = 0